import React, { useEffect, useState } from 'react';
import { SaveBudgetUnitType, GetBudgetUnitType, SetBudgetUnitTypeActive, SetBudgetUnitTypeOrder } from '../API/Budget';
import { Button, ListGroup, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faChevronUp, faChevronDown, faCheck, faBan } from '@fortawesome/free-solid-svg-icons';
import { Link, useHistory } from 'react-router-dom';

export default props => {
    const [unit, setUnit] = useState({
        budgetUnitTypeId: null,
        description: ""
    });
    const [error, setError] = useState("")

    let history = useHistory();

    useEffect(() => {
        if (props.match.params.id !== 'new')
            LoadUnit(props.match.params.id)
        else {
            setUnit({ budgetUnitTypeId: -1, description: "" })
        }
    }, [props.match.params.id])

    const LoadUnit = (id) => {
        GetBudgetUnitType(id)
            .then(res => {
                setUnit(res.data)
            })
    }

    const SetDescription = (des) => {
        let u = { ...unit }
        u.description = des;
        setUnit(u);
    }

    const SaveUnit = () => {
        let data = { ...unit }
        SaveBudgetUnitType(data)
            .then(res => {
                history.push("/Admin/BudgetUnits");
            })
            .catch(err => {
                setError("Failed to save budget unit. Please try again.")
            })
    }

    return (
        <div className="container">
            <div className="row">
                {unit.budgetUnitTypeId >= 0 &&
                    <div className="col">
                        <h3>Edit Budget Unit Type</h3>
                    </div>
                }
                {unit.budgetUnitTypeId === -1 &&
                    <div className="col">
                        <h3>New Budget Unit Type</h3>
                    </div>
                }
            </div>

            <div className="divider my-2" />
            <div className="row">
                <input type="text"
                    value={unit.description}
                    className='enc-input-100'
                    onChange={e => SetDescription(e.target.value)}
                />
            </div>
            <div className=" m-1" />
            <div className="row">
                <div className="col text-right">
                    <Button className="enc-button" onClick={SaveUnit}>Save</Button>
                </div>
            </div>

            <div className="my-3" />
        </div>
    )
}
